import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { Grid } from "@mui/material";
import theme from "../theme";

interface CsSelectVoucherProps {
  imageSrc: string;
  voucherName: string;
  price: number;
  onVoucherCountChange: Function;
  count: number;
  limitVoucher: number;
}

const RoundButton = styled(Button)({
  borderRadius: "50%",
  width: "30px",
  height: "30px",
  minWidth: "auto",
  padding: 0,
  borderColor: "#999",
  color: "#999",
  fontSize: "1.2rem",
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

const CsSelectVoucher: React.FC<CsSelectVoucherProps> = ({
  count,
  imageSrc,
  voucherName,
  price,
  onVoucherCountChange,
  limitVoucher,
}) => {
  const increaseCount = () => {
    onVoucherCountChange(count + 1);
  };

  const decreaseCount = () => {
    if (count > 0) {
      onVoucherCountChange(count - 1);
    }
  };
  return (
    <Card
      sx={{
        display: "flex",
        marginBottom: "1rem",
        borderRadius: "8px",
        justifyContent: "center",
        maxHeight: "14rem",
        border: theme.border?.newGreyBorder,
      }}
    >
      <Grid
        container
        style={{
          display: "flex",
          alignItems: "center",
          padding: "1rem",
          width: "100%",
          borderRadius: "5px",
          height: "100%",
          maxHeight: "10rem",
        }}
      >
        <Grid item xs={5} borderRadius={"5px"} overflow={"hidden"}>
          <CardMedia
            component="img"
            sx={{ objectFit: "cover", height: "8rem" }}
            image={imageSrc}
            alt="Voucher"
          />
        </Grid>
        <Grid item xs={7}>
          <CardContent>
            <Typography
              variant="h5"
              style={{
                fontFamily: theme.font?.fontFamily.primary,
                fontSize: "1rem",
                display: "flex",
                justifyContent: "start",
                fontWeight: 500,
              }}
            >
              {voucherName}
            </Typography>

            <Grid
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "1rem  ",
                width: "100%",
                justifyContent: "start",
              }}
            >
              <RoundButton variant="outlined" onClick={decreaseCount}>
                -
              </RoundButton>

              <Typography
                variant="h6"
                component="div"
                style={{
                  margin: "0 10px",
                  color: "#FFA500",
                  fontFamily: theme.font?.fontFamily.primary,
                }}
              >
                {count}
              </Typography>

              <RoundButton
                variant="outlined"
                onClick={increaseCount}
                disabled={count >= limitVoucher}
              >
                +
              </RoundButton>
            </Grid>
          </CardContent>
        </Grid>
        <div style={{ flex: 2 }}></div>
      </Grid>
    </Card>
  );
};

export default CsSelectVoucher;
